/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LgtmStagedGachaRequest } from '../../models/lgtm-staged-gacha-request';
import { LgtmStagedGachaResponse } from '../../models/lgtm-staged-gacha-response';

export interface AdminServiceLgtmStagedGacha$Params {
      body: LgtmStagedGachaRequest
}

export function adminServiceLgtmStagedGacha(http: HttpClient, rootUrl: string, params: AdminServiceLgtmStagedGacha$Params, context?: HttpContext): Observable<StrictHttpResponse<LgtmStagedGachaResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceLgtmStagedGacha.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LgtmStagedGachaResponse>;
    })
  );
}

adminServiceLgtmStagedGacha.PATH = '/api/v3/gateway/admin/stage/gacha/lgtm';
